import { useState, useRef, useEffect, useMemo, useReducer } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Screen from "@components/Screen";

import * as Material from "@mui/material";

import "./styles.scss";
import { useCommunity } from "contexts/community";

import ManageSessionModal from "@modals/Content/ManageSession";
import ManageGroupModal from "@modals/Group/ManageGroup";
import UsersModal from "@components/Modals/UsersModal";

import ManageMaterialModal from "@modals/Material/ManageMaterial";


import Hero from './Header';
import CoursesBar from './CoursesBar';
import MaterialsBar from './MaterialsBar';
import PlansSidebar from './PlansSidebar';
import Group from './Group';


export default function Community() {
  let { slug } = useParams();

  const navigate = useNavigate();

  const { community, loadCommunities, loading: communityLoading } = useCommunity();

  const [loading, setLoading] = useState(true);

  const [info, setInfo] = useState({});

  const [_, forceUpdate] = useReducer((x) => x + 1, 0);

  document.title = info?.name || "Comunidade";

  const REF_createSessionModal = useRef();
  const REF_configGroupModal = useRef();
  const REF_materialModal = useRef()
  const REF_membersModal = useRef();

  const REF_headerElementOpacity = useRef(1)
  const REF_headerElement = useRef()
  const REF_container = useRef()
  const REF_containerInitialRadius = useRef(null)

  useEffect(() => {
    setLoading(true);
  }, [slug]);

  useEffect(() => {
    if (loading && !communityLoading) handleLoadCommunity();
  }, [loading, communityLoading]);

  function triggerCreateNewContent() {
    REF_createSessionModal.current.open(
      { community: info.id },
      async function (result) {
        await loadCommunities();
        forceUpdate();
        navigate("section/" + result.id);
      }
    );
  }
  function triggerEditGroup(group = null) {
    REF_configGroupModal.current.open(
      {
        group,
        community: info,
      },
      async function (result) {
        console.log(result);
        setLoading(true)
      }
    );
  }
  function triggerOpenMembers() {
    REF_membersModal.current.open(info.id);
  }
  function triggerOpenMaterialEdit(info) {
    REF_materialModal.current.open(info, function (result) {
      console.log(result)
      if (result?.id) {
        setLoading(true)
      }
    })
  }

  async function handleLoadCommunity() {
    setInfo({});
    try {
      const data = await community.load(slug, 'slug')
      setInfo({ ...data });
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  function handleScreenScroll(e) {
    const offset = e?.offset || 0;
    const headerEl = REF_headerElement.current;
    const containerEl = REF_container.current;
    if (!headerEl) return;

    const progress = Math.min(1, Math.max(0, offset / 280));
    const newOpacity = 1 - 0.75 * progress; // 1 at 0px -> 0.3 at 300px+

    REF_headerElementOpacity.current = newOpacity;
    headerEl.style.opacity = String(newOpacity);

    if (containerEl) {
      const widthProgress = Math.min(1, Math.max(0, offset / 300));
      const newWidth = 90 + 10 * widthProgress; // 90% -> 100%
      containerEl.style.width = newWidth + '%';
    }

    if (offset > 300) {
      document.querySelector('.banner-effect-community').style.opacity = 0
      containerEl.style.backgroundColor = '#070707d2'
    } else {
      document.querySelector('.banner-effect-community').style.opacity = 0.15
      containerEl.style.backgroundColor = '#070707a2'
    }

    // Border radius reduction between 500 and 600 offset
    if (containerEl) {
      if (REF_containerInitialRadius.current === null) {
        const cs = window.getComputedStyle(containerEl);
        const radiusPx = parseFloat(cs.borderTopLeftRadius || '0');
        REF_containerInitialRadius.current = isNaN(radiusPx) ? 0 : radiusPx;
      }

      if (offset <= 300) {
        containerEl.style.borderRadius = REF_containerInitialRadius.current + 'px';
      } else if (offset >= 600) {
        containerEl.style.borderRadius = '0px';
      } else {
        const t = (offset - 300) / 100; // 0..1
        const newRadius = Math.max(0, REF_containerInitialRadius.current * (1 - t));
        containerEl.style.borderRadius = newRadius + 'px';
      }
    }
  }

  const Container = useMemo(
    () => (
      <>
        {/*info?.hero && <img src={info?.hero} className="banner-effect-community" />*/}

        <Screen
          onScroll={handleScreenScroll}
          className="community"
          key={slug}
          loading={loading}
          disablePaddingBottom
        >
          <>
            <div className="hero">
              {info?.hero && <img src={info?.hero} className="hero-img" />}
            </div>

            {
              !loading && <div className="community-body">
                <div className="community-container-body pb-6">
                  <Hero info={info} handleOpenUsers={triggerOpenMembers} loading={loading} />

                  <CoursesBar info={info} key={info?.id} handleCreateNew={triggerCreateNewContent} loading={loading} />

                  <Material.Divider className="mt-1 mb-4" />
                  <MaterialsBar info={info} key={info?.id} handleChangeMaterial={triggerOpenMaterialEdit} loading={loading} />
                  <Material.Divider className="" />

                  <Group community={info} triggerEdit={triggerEditGroup} loading={loading} />
                </div>

                <PlansSidebar community={info} loading={loading} />
              </div>
            }


          </>
        </Screen >

        <ManageSessionModal modalRef={REF_createSessionModal} />
        <ManageGroupModal modalRef={REF_configGroupModal} />
        <UsersModal modalRef={REF_membersModal} />
        <ManageMaterialModal modalRef={REF_materialModal} />
      </>
    ),
    [slug, loading, info, _]
  );

  return Container;
}





// Skeleton Components
function CommunitySkeleton() {
  return (
    <>
      {/* Members Bar Skeleton */}
      <div className="px-2" style={{ marginTop: '-50px' }}>
        <Material.Skeleton variant="rectangular" width="100%" height={200} style={{ borderRadius: 18, marginTop: '16px' }} />
      </div>

      <div className="members-bar-content mt-2 px-3">
        <div className="members-bar-content-inner">
          <div className="community-title-container">
            <Material.Skeleton variant="text" width={300} height={48} style={{ marginBottom: '12px' }} />
          </div>
          <div className="communiy-description-info">
            <div className="community-avatars">
              <Material.Skeleton variant="circular" width={30} height={30} style={{ marginRight: '7px' }} />
              <Material.Skeleton variant="circular" width={30} height={30} style={{ marginRight: '7px' }} />
            </div>
            <Material.Skeleton variant="text" width={80} height={16} style={{ marginRight: '8px' }} />
            <Material.Skeleton variant="text" width={100} height={16} />
          </div>
        </div>
      </div>

      {/* Courses Bar Skeleton */}
      <div className="courses-bar px-2">
        <div className="courses-list mt-3">
          {/* Course 1 */}
          <div className="course">
            <div className="course-box-effect course-box">
              <Material.Skeleton variant="rectangular" width="100%" height="100%" style={{ borderRadius: 12 }} />
            </div>
            <div className="course-box-effect course-box">
              <Material.Skeleton variant="rectangular" width="100%" height="100%" style={{ borderRadius: 12 }} />
            </div>
            <div className="course-box">
              <Material.Skeleton variant="rectangular" width="100%" height="100%" style={{ borderRadius: 12 }} />

              <div className="course-info-section">
                <Material.Skeleton variant="text" width="80%" height={24} style={{ marginBottom: '8px' }} />
                <Material.Skeleton variant="text" width="90%" height={18} style={{ marginBottom: '16px' }} />
                <Material.Skeleton variant="rectangular" width={100} height={36} style={{ borderRadius: 18 }} />
              </div>
            </div>
          </div>

          {/* Course 2 */}
          <div className="course">
            <div className="course-box-effect course-box">
              <Material.Skeleton variant="rectangular" width="100%" height="100%" style={{ borderRadius: 12 }} />
            </div>
            <div className="course-box-effect course-box">
              <Material.Skeleton variant="rectangular" width="100%" height="100%" style={{ borderRadius: 12 }} />
            </div>
            <div className="course-box">
              <Material.Skeleton variant="rectangular" width="100%" height="100%" style={{ borderRadius: 12 }} />

              <div className="course-info-section">
                <Material.Skeleton variant="text" width="75%" height={24} style={{ marginBottom: '8px' }} />
                <Material.Skeleton variant="text" width="85%" height={18} style={{ marginBottom: '16px' }} />
                <Material.Skeleton variant="rectangular" width={100} height={36} style={{ borderRadius: 18 }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Group Section Skeleton */}
      <div className="px-2 mt-5">
        <div className="courses mb-1">
          <Material.Skeleton variant="circular" width={24} height={24} style={{ marginRight: '8px' }} />
          <Material.Skeleton variant="text" width={120} height={24} />
        </div>

        <div className="group-select-row mb-4 mt-2">
          <Material.Skeleton variant="rectangular" width="100%" height={56} style={{ borderRadius: 8 }} />
          <Material.Skeleton variant="circular" width={40} height={40} style={{ marginLeft: '8px' }} />
          <Material.Skeleton variant="circular" width={40} height={40} style={{ marginLeft: '8px' }} />
        </div>

        {/* Feed Skeleton */}
        <div className="feed-group">
          <Material.Skeleton variant="rectangular" width="100%" height={200} style={{ borderRadius: 12, marginBottom: '16px' }} />
          <Material.Skeleton variant="rectangular" width="100%" height={150} style={{ borderRadius: 12, marginBottom: '16px' }} />
          <Material.Skeleton variant="rectangular" width="100%" height={180} style={{ borderRadius: 12 }} />
        </div>
      </div>
    </>
  );
}
